import axios from './axios'
import qs from "qs";

function service(endpoint) {

    function arranged(data) {
        return axios.get(`${endpoint}/arranged`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    function matrix(data) {
        return axios.get(`${endpoint}/matrix`, { params: data, paramsSerializer: params => qs.stringify(params, { encode: false })  }).then(response => {
            return response.data;
        }).catch(e => {
            throw e
        });
    }

    return {
        arranged,
        matrix
    }
}

export default service
